import axios from 'axios';
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { ProjectConfig } from 'Global';
import TopBar from 'elements/TopBar/TopBar';
import FiltersApplied from 'elements/Filters/FiltersApplied';
import Cookies from 'universal-cookie';
import { getFiestasLabel } from 'hooks/useLabels';

export default function FiestasList(props: any) {
  const { inHome } = props;

  const filters = [
    { type: "text", label: getFiestasLabel('common_filter_label'), name: "titulo", value: "" },
  ];

  const [filtersValues, setFiltersValues] = useState<any>({});
  const [list, setList] = useState<any[]>([]);

  const cookies = new Cookies();
  const user_id = cookies.get('user_id');
  const lang_id = localStorage.getItem('lang_id') || '1';

  const modulo = inHome ? '' : 'Comunes';

  const localizedCommonTitle = (item: any) => {
    const meta = item?.common_meta;
    if (!meta?.is_common) {
      return String(item?.title || item?.name || '').trim();
    }

    const familyKey = String(meta.family_label_key || '').trim();
    const familyFallback = String(
      meta.family_title || meta.canonical_title || item?.title || item?.name || ''
    ).trim();
    const familyLabel = familyKey
      ? getFiestasLabel(familyKey)
      : familyFallback;

    const variantKey = String(meta.variant_key || '').trim();
    if (!variantKey) {
      return familyLabel || familyFallback;
    }

    const variantLabel = getFiestasLabel(`common_variant_${variantKey}`);
    return [familyLabel || familyFallback, variantLabel]
      .filter(Boolean)
      .join(' · ');
  };

  const setFilters = (tempFilters: any) => {
    setFiltersValues(tempFilters);
  };

  useEffect(() => {
    props.setLoading(true);

    axios.get(ProjectConfig.api_url, {
      params: {
        request: 'fiestas_list2',
        filters: filtersValues,
        principal: '',
        page: 1,
        full_list: true,
        user_id: user_id,
        modulo: modulo,
        lang_id: lang_id,
      }
    })
      .then((response) => {
        setList(response.data.list || []);
        props.setLoading(false);
      })
      .catch((err) => {
        console.log(err?.data || err);
        props.setLoading(false);
      });
  }, [filtersValues, lang_id]);

  return (
    <div id='Fiestas' className='module_container'>
      {!inHome && (
        <>
          <div className="module_topBar">
            <TopBar
              title={getFiestasLabel('propios_titulo')}
              filters={filters}
              setFilters={setFilters}
              setLoading={props.setLoading}
            />
          </div>
          <FiltersApplied
            filtersValues={filtersValues}
            setFiltersValues={setFiltersValues}
          />
        </>
      )}

      {list.length > 0 && (
        <div className='module_content'>
          <div id="task_list_container" className="flex_column">
            {list.map((list_item, key) => (
              <Link
                to={`/fiestas/${list_item.fiesta_id}`}
                onClick={() => props.setLoading(true)}
                className='CardList'
                key={key}
              >
                <div className='CardListLeft'>
                  {list_item.image && (
                    <img
                      className='ListImage'
                      src={list_item.image}
                      alt={`Imagen de ${list_item.title || list_item.name}`}
                    />
                  )}
                </div>

                <div className='CardListRight'>
                  <span className='CardListSubTitle'>
                    <strong>{localizedCommonTitle(list_item).toLocaleUpperCase()}</strong>
                  </span>
                </div>
              </Link>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
